import React from 'react'
import fixxbank from '../Assets/logo-fixxbank2.webp'
import card from '../Assets/mockup-two-phones.webp'
import Introduction from '../Components/Introduction'
import Services from '../Components/Services'
import CardServices from '../Components/CardServices'
import GeographicPresence from '../Components/GeographicPresence'
import CreditCard from '../Components/CreditCard'
import stone from '../Assets/maquininha-stone.webp'
import sede from '../Assets/sede-fixxbank.webm'

function Fixxbank({ id }) {
  return (
    <section id={id}>
      <div className="video-background flex-center full-window">
        <video autoPlay loop muted className="background-video">
          <source src={sede} type="video/mp4" />
          Seu navegador não suporta o vídeo.
        </video>
        <Introduction
          srcLogo={fixxbank}
          altLogo="Fixxbank"
          description={
            <>
              O FixxBank se posiciona como uma{' '}
              <span>inovadora instituição</span> no setor financeiro digital,
              contando com a aprovação dos órgãos reguladores necessários, como
              a <span>Comissão de Valores Mobiliários (CVM)</span>,{' '}
              <span>Banco Central do Brasil (BACEN) de número 033</span> e
              outros, garantindo sua operação dentro dos mais rigorosos padrões
              de legalidade e segurança. Seu compromisso é oferecer uma
              experiência bancária simplificada e atual, por meio de um{' '}
              <span>cartão e aplicativo próprio</span>, pilares centrais na
              prestação de seus serviços. <br />
              <br />{' '}
              <span style={{ background: '#FF8B00', padding: '5px' }}>
                Use o código “sejafixx” e faça parte do novo
              </span>
            </>
          }
          color="white"
          img={true}
          srcProduct={card}
          altProduct="Cartão da Fixxbank"
        />
      </div>
      <div className="flex-center flex__gap-100">
        <div>
          <div className="img img-350">
            <img src={stone} alt="maquininha de cartão Stone" />
          </div>
        </div>
        <CreditCard />
      </div>

      <Services backgroundColor="#ecf0f1" colorTitle="#090A0A">
        <CardServices
          title="Cartão FixxBank"
          description="O Cartão FixxBank proporciona praticidade e segurança aos usuários em compras e transações financeiras, tanto físicas quanto online. Criado para facilitar o dia a dia, oferece acesso a uma ampla rede de estabelecimentos, aceitando as principais bandeiras. Isso permite ao cliente realizar compras em supermercados, lojas físicas ou online, sempre com uma experiência fluida e sem complicações.​"
          backgroundColor="#431A60"
          colorTitle="white"
          colorContent="white"
          height="350px"
        />
        <CardServices
          title="Aplicativo Próprio"
          description="O aplicativo do FixxBank foi desenvolvido para otimizar a experiência do usuário, permitindo um gerenciamento completo das finanças. Com ele, é possível acompanhar gastos, realizar transações de forma rápida e segura, além de acessar funcionalidades essenciais, como pagamentos, transferências, emissão de boletos e controle de contas. Tudo isso em uma plataforma intuitiva e fácil de usar."
          backgroundColor="#431A60"
          colorTitle="white"
          colorContent="white"
          height="350px"
        />
        <CardServices
          title="Plataforma Financeira Completa"
          description="Além do cartão e do
        aplicativo, o FixxBank oferece uma gama completa
        de serviços financeiros, incluindo PIX, máquinas de
        cartão com parceria Stone, emissão de boletos,
        transferências em geral, e uma inovadora tecnologia
        de pagamentos em lote. Tudo isso é suportado por um
        atendimento ao cliente eficaz, tornando as
        transações bancárias uma experiência simples e
        descomplicada."
          backgroundColor="#431A60"
          colorTitle="white"
          colorContent="white"
          height="350px"
        />
        <CardServices
          title="Pagamentos em lotes eficientes"
          description="Os pagamentos em lotes do FixxBank facilitam transações em grande volume, permitindo processar múltiplos pagamentos ao mesmo tempo, economizando tempo e reduzindo erros. Ideal para empresas com alta demanda, como fornecedores ou funcionários, o serviço oferece controle total de valores, datas e destinatários, tudo pelo app."
          backgroundColor="#431A60"
          colorTitle="white"
          colorContent="white"
          height="350px"
        />
      </Services>

      <GeographicPresence
        description={
          <>
            Sede própria e extensões pelo país: com sua sede localizada no
            prédio do grupo Fixx, e tendo escritório de apoio em São Paulo e
            outros estados, como Santa Catarina, mostra a solidez da operação e
            sua capacidade de atendimento e suporte. Como uma instituição
            digital, o FixxBank tem a capacidade de{' '}
            <span>
              atender clientes em todo o território nacional e também no
              exterior
            </span>
            , superando barreiras físicas e democratizando o acesso a serviços
            financeiros de alta qualidade.
          </>
        }
        backgroundColor="#ecf0f1"
      />
    </section>
  )
}

export default Fixxbank
